import useAuth from '../hooks/useAuth';
import Login from './Login';
import MyCards from './MyCards';

export default function Home() {
    const { user, logout } = useAuth();
    if (!user) return <Login />;
    return (
        <div className="home">
            <div className="topbar">
                <div>Vítej, {user.name}</div>
                <button onClick={logout}>Odhlásit</button>
            </div>
            <h2>Moje karty</h2>
            <MyCards />
        </div>
    );
}
